module.exports = __webpack_public_path__ + "static/media/basket.5835404a.svg";